import { render } from "./HomepageRodekruisvlaanderen.vue?vue&type=template&id=3aab0da0&scoped=true"
import script from "./HomepageRodekruisvlaanderen.vue?vue&type=script&lang=js"
export * from "./HomepageRodekruisvlaanderen.vue?vue&type=script&lang=js"

import "./HomepageRodekruisvlaanderen.vue?vue&type=style&index=0&id=3aab0da0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aab0da0"]])

export default __exports__